export const normalizePositiveNumber = (
  value?: string | number | null,
  max?: number,
): number | '' => {
  if (value === undefined || value === null || value === '') {
    return '';
  }

  const numericValue = Number(value);

  if (Number.isNaN(numericValue)) {
    return '';
  }

  let result = Math.max(0, numericValue);

  if (max !== undefined) {
    result = Math.min(result, max);
  }

  return result;
};
